
import { useTranslation } from "react-i18next";
import { IChartCountModel, NotificationDetailActionEnum } from "./NotificationsDetailChartUtils";
import { AlarmNotificationsType } from "../../../../services/alarm-data-service/Models";
import {  Box, ListItem, ListItemButton, ListItemText, useTheme  } from "@mui/material";
import ActionMenu from "../../../action-menu/ActionMenu";
import {HighchartsReact} from "highcharts-react-official";
import Highcharts from "highcharts";
import { useEffect, useRef } from "react";
import { isMobile, isTablet } from "react-device-detect";

export type NotificationsDetailListItemProps = {
    notificationsType: AlarmNotificationsType,
    item: IChartCountModel,
    selected?: boolean,
    onEdit: (model: IChartCountModel) => void,
    onSelected: (model: IChartCountModel) => void
};

export function NotificationsDetailListItem({
    notificationsType,
    item,
    selected,
    onEdit,
    onSelected

}: NotificationsDetailListItemProps) {

    const isPhone = isMobile && !isTablet;
    const { t } = useTranslation();
    const theme = useTheme();
    const itemRef = useRef<HTMLLIElement>(null);
   

    useEffect(() => {

        if (itemRef.current && selected) {

            itemRef.current?.scrollIntoView({ behavior: 'smooth' });
        }

    }, [
        selected
    ]);

    return (
        <ListItem
            ref={itemRef}
            disablePadding 
            disableGutters
            secondaryAction={
                item.isMenuVisible && ((isPhone && notificationsType !== AlarmNotificationsType.Recipients) || !isPhone)
                    ? <ActionMenu
                        actionItems={
                            [{
                                label: t(notificationsType === AlarmNotificationsType.Setpoints ||
                                    notificationsType === AlarmNotificationsType.Objects ?
                                    "actions.editAlarmSetpoint" :
                                    "actions.editUser"
                                ),
                                action: NotificationDetailActionEnum.Edit,
                                onClick: () => onEdit(item),
                                order: 0
                            }]}
                    />
                    : undefined
            }
            >
            <ListItemButton 
                sx={{
                    paddingTop: 0,
                    paddingBottom: 0,
                    backgroundColor: selected ? `${theme.palette.grey[400]}!important` : undefined
                }}
                selected={selected}
                onClick={() => onSelected(item)}>

                <ListItemText primary={item.elynxObject.displayText} 
                    sx={{
                        display: 'flex',
                        flex: '1 1 40%'
                    }}
                    slotProps={{
                        primary: {
                            sx: {
                                fontSize: '.8rem',
                                whiteSpace: 'normal',
                            }
                        }
                    }} />


                <Box sx={{
                    position: 'relative',
                    padding: 0,
                    width: '60%',
                    borderLeft: '1px solid silver!important',
                    maxWidth: 275 }}>

                    <HighchartsReact
                        highcharts={Highcharts}
                        options={item.chartOptions}
                        //callback={chartCallback}
                        containerProps={{
                            style: { height: "100%" }
                        }}
                    />
                </Box>

            </ListItemButton>
        </ListItem>
    );
}
